import { LmIconFilledFilesFile, LmIconOutlineFilesFile } from '@mes-ui/lemma/icons';
import { WidgetIconProps } from 'icons/widgets/types';

const IconStudyDocumentsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineFilesFile {...rest} /> : <LmIconFilledFilesFile {...rest} />;

export default IconStudyDocumentsCommon;
